<template>
    <div class="container-activity">
      <MpNavbar active="coffee" />
      <MpTitle title="我的咖啡豆（Beta）" intro="再此页面可以新增、编辑、删除、导入咖啡豆" />
      <div class="content-table" v-show="tableData">
        <!-- height="300" :loading="loading" -->
        <vxe-toolbar>
          <template #buttons>
            <vxe-button @click="reflash">刷新</vxe-button>
            <vxe-button @click="downloadTemplate">下载模板</vxe-button>
            <div class="btn-upload">
              <div class="upload-text">导入咖啡豆.xlsx</div>
              <input class="upload-input" type="file" @change="upload($event)" style="width: 320px;"
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel">
            </div>
          </template>
        </vxe-toolbar>
        <vxe-table round border highlight-hover-row resizable :data="tableData">
          <vxe-table-column type="seq" width="60"></vxe-table-column>
          <!-- <vxe-table-column field="id" title="ID" width="60"></vxe-table-column> -->
          <vxe-table-column field="createTime" :formatter="formatTime" title="创建时间" width="150"></vxe-table-column>
          <vxe-table-column field="name" title="咖啡豆名称"  width="300"></vxe-table-column>
          <vxe-table-column title="庄园 / 豆种 / 批次">
            <template #default="{ row, rowIndex }">
                <div class="small-text">
                    庄园：{{ row.estate || '无' }}
                </div>
                <div class="small-text">
                    豆种：{{ row.kind || '无' }}
                </div>
                <div class="small-text">
                    批次：{{ row.batch || '无' }}
                </div>
            </template>
          </vxe-table-column>
          <vxe-table-column title="处理方式 / 烘培程度">
            <template #default="{ row, rowIndex }">
                <div class="small-text">
                    处理方式：
                    <span v-if="row.method" v-for="item in constantMethods" >
                      <span v-if="row.method == item.key">
                        {{ item.value }}
                      </span>
                    </span>
                    <span v-if="!row.method">
                      无
                    </span>
                    <span v-if="row.method == 9 && row.customMethod">
                      （{{ row.customMethod }}）
                    </span>
                </div>
                <div class="small-text">
                    烘培程度：
                    <span v-if="row.deep" v-for="item in constantDeep" >
                      <span v-if="row.deep == item.key">
                        {{ item.value }}
                      </span>
                    </span>
                    <span v-if="!row.deep">
                      无
                    </span>
                </div>
            </template>
          </vxe-table-column>
          <vxe-table-column  title="国家 / 地区 / 产区">
            <template #default="{ row, rowIndex }">
                <div class="small-text">
                    国家：{{ row.country || '无' }}
                </div>
                <div class="small-text">
                    地区：{{ row.region || '无' }}
                </div>
                <div class="small-text">
                    产区：{{ row.prodRegion || '无' }}
                </div>
            </template>
          </vxe-table-column>
          <vxe-table-column  title="含水量 / 密度 / 水活性">
            <template #default="{ row, rowIndex }">
                <div class="small-text">
                  含水量：{{ row.water ? row.water + '%' : '无' }}
                </div>
                <div class="small-text">
                  密度：{{ row.density || '无' }}
                </div>
                <div class="small-text">
                  水活性：{{ row.waterActivity || '无' }}
                </div>
            </template>
          </vxe-table-column>
          <vxe-table-column  title="豆色值 / 粉色值">
            <template #default="{ row, rowIndex }">
                <div class="small-text">
                  豆色值：{{ row.color || '无' }}
                </div>
                <div class="small-text">
                  粉色值：{{ row.pink || '无' }}
                </div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="remarks" title="备注"></vxe-table-column>
          <vxe-table-column title="操作"  width="110">
            <template #default="{ row, rowIndex }">
              <van-button @click="openEdit(row)" color="#489D80" size="small" round>编辑</van-button>
              <van-button @click="confirmDel(row , rowIndex)" style="margin-left: 6px;" color="#fd4343" size="small" round>删除</van-button>
            </template>
          </vxe-table-column>
        </vxe-table>
        <vxe-pager background size="small" :loading="loading" :current-page="tablePage.currentPage" :page-size="tablePage.pageSize" :total="tablePage.totalResult" :page-sizes="[10, 20, 100]" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" @page-change="handlePageChange">
        </vxe-pager>
      </div>
      <!-- 弹窗 -->
      <EditCoffee :show="showEdit" :info="info" v-if="info && info.name" @close="closeEdit" />
    </div>
  </template>
  
  <script>
    import MpNavbar from '../../components/mp/navbar'
    import MpTitle from '../../components/mp/title'
    import EditCoffee from '../../components/mp/editCoffee'
    import { apiBeansList, apiBeansDelete } from '../../request/api'
    import Vue from 'vue';
    import { Button,Toast,Dialog } from 'vant';
  
    Vue.use(Button);
  
    export default {
      components: {
        MpNavbar,
        MpTitle,
        EditCoffee
      },
      name: 'Index',
      // props: {
      //   msg: String
      // },
      data() {
        return {
          loading: false,
          tableData: null,
          tablePage: {
            currentPage: 1,
            pageSize: 10,
            totalResult: null
          },
          constantActivityCategory: null,
          constantDeep: null,
          constantMethods: null,
          showEdit: false,
          info: null,
        }
      },
      mounted() {
        this.init()
      },
      methods: {
        init() {
          this.constantActivityCategory = JSON.parse(localStorage.getItem("constantActivityCategory"))
          this.getBeansList()
          this.getConstantDeep()
          this.getConstantMethods()
        },
        reflash() {
          this.tablePage = {
            currentPage: 1,
            pageSize: 10,
            totalResult: null
          }
          this.tableData = null
          this.getBeansList()
        },
        getBeansList() {
          let self = this
          self.loading = true
          apiBeansList({
            page: self.tablePage.currentPage,
            size: self.tablePage.pageSize,
          }).then(res => {
            console.log(res.data)
            self.tableData = res.data.items
            self.tablePage.totalResult = res.data.count
            self.loading = false
          }).catch(err => {
            console.log(err)
            self.loading = false
          })
        },
        handlePageChange({ currentPage, pageSize }) {
          console.log(currentPage)
          console.log(pageSize)
          this.tablePage.currentPage = currentPage
          this.tablePage.pageSize = pageSize
          this.getBeansList()
        },
        // 弹窗
        openEdit(item){
          this.info = JSON.parse(JSON.stringify(item))
          this.showEdit = true
        },
        closeEdit(value) {
          this.showEdit = false
          this.info = null
          if(value){
            this.reflash()
          }
        },
        // 按钮-删除
        confirmDel(item,index){
          Dialog.confirm({
            title: '提示',
            message: '确定删除「'+ item.name +'」吗？',
          })
            .then(() => {
              // on confirm
              this.delBean(item,index)
            })
            .catch(() => {
              // on cancel
            });
        },
        delBean(item,index){
          let self = this
          let params = {
            uuid: item.uuid
          }
          apiBeansDelete(params).then(res => {
            console.log(res.data)
            self.tableData.splice(index,1)
            Toast.success('删除成功');
          }).catch(err => {
            console.log(err)
          })
        },
        // 基础信息
      getConstantDeep(){
        let deep = localStorage.getItem('constantDeep')
        if(deep && deep.length > 0){
          // 字符串转换为json
          this.constantDeep = JSON.parse(deep)
        }else{
          setTimeout(() => {
            this.getConstantDeep()
          }, 500);
        }
      },
      getConstantMethods(){
        let methods = localStorage.getItem('constantMethods')
        if(methods && methods.length > 0){
          this.constantMethods = JSON.parse(methods) 
        }else{
          setTimeout(() => {
            this.getConstantMethods()
          }, 500);
        }
      },
        // 按钮-上传
        downloadTemplate() {
          let exportUrl = '/file/upload_beans_template.xlsx'
          window.open(exportUrl, '_blank'); // 新开窗口下载
        },
        upload(event) {
            let self = this
            var XLSX = require("xlsx");
            // let inputDOM = this.$refs.inputer;
            if (!event.target.value) {
                Toast({
                  message: "读取失败",
                })
                return;
            }
            // 加载中
            Toast.loading({
              message: '正在解析文件',
              forbidClick: true,
            });
            let file = event.target.files[0]

            let reader = new FileReader();
            reader.onload = function (e) {
                let data = e.target.result;
                let excelData = XLSX.read(data, {
                    type: 'binary'
                });
                //excelData.SheetNames[0]是获取Sheets中第一个Sheet的名字
                //excelData.Sheets[Sheet名]获取第一个Sheet的数据
                let json = XLSX.utils.sheet_to_json(excelData.Sheets[excelData.SheetNames[0]]);
                self.excelChack(json)
            };
            reader.readAsBinaryString(file);
        },
        excelChack(json) {
            // loading
            // 名称	国家	庄园	豆种	处理方式	其他处理方式	地区	产区	批次	含水量%	密度	水活性	豆色值	豆粉值	烘培程度	备注
            console.log("=====excelChack-json====A")
            console.log(json)
            let params = []
            for (let index = 0; index < json.length; index++) {
                if (json[index].名称 ) {
                    // 汇总
                    let obj = {
                          name: json[index].名称, //简称
                          country: json[index].国家 || null, //国家
                          estate: json[index].庄园 || null, //庄园
                          kind: json[index].豆种 || null, //种类
                          prodRegion: json[index].产区 || null, //产区
                          region:  json[index].地区 || null, //地区
                          batch: json[index].批次 || null, //批次
                          remarks: json[index].备注 ||null, //备注
                          customMethod: json[index].其他处理方式 || null, //其他处理方式
                          water: json[index].含水量 || null, //含水率
                          density: json[index].密度 || null, //密度
                          waterActivity : json[index].水活性 || null, //水活性
                          color: json[index].豆色值 || null, // 豆色值
                          pink: json[index].粉色值 || null, //粉色值
                          cover: null, //图片地址
                          deep: null, //烘培程度
                          method: null, //处理方式
                    }
                    // 烘培程度
                    for (let i = 0; i < this.constantDeep.length; i++) {
                      if(this.constantDeep[i].value == json[index].烘培程度){
                        console.log(this.constantDeep[i].value , json[index].烘培程度)
                        obj.deep = this.constantDeep[i].key
                      }
                    }

                    // 处理方式
                    for (let i = 0; i < this.constantMethods.length; i++) {
                      if(this.constantMethods[i].value == json[index].处理方式){
                        console.log(this.constantMethods[i].value , json[index].处理方式)
                        obj.method = this.constantMethods[i].key
                      }
                    }

                    params.push(obj)
                }
            }
            console.log("=====excelChack-params====B")
            console.log(params)
            // 关闭loading
            Toast.clear()
            if(params && params.length > 0){
              this.$router.push({
                name: 'MpCoffeeInput',
                params: {
                  coffeeInfo: params
                }
              })
            }else{
              Toast({
                message: "解析Excel失败",
              })
            }
        },
        // 格式化
        formatTime({ cellValue, row, column }) {
          let time = new Date(cellValue)
          let year = time.getFullYear()
          let month = time.getMonth() + 1
          let date = time.getDate()
          let hours = time.getHours()
          let minute = time.getMinutes()
          let second = time.getSeconds()
  
          if (month < 10) { month = '0' + month }
          if (date < 10) { date = '0' + date }
          if (hours < 10) { hours = '0' + hours }
          if (minute < 10) { minute = '0' + minute }
          if (second < 10) { second = '0' + second }
          return year + '.' + month + '.' + date + ' ' + hours + ':' + minute
        },
        formatStste({ cellValue, row, column }) {
          if (cellValue == 1) {
            return "🟢 进行中"
          }
          else if (cellValue == 2) {
            return "🔴 已结束"
          } else {
            return "未知状态"
          }
        },
        formatCups({ cellValue, row, column }) {
          return cellValue + "个"
        },
        formatTable({ cellValue, row, column }) {
          if (cellValue == 1) {
            return "简易杯测表"
          } else if(cellValue == 2){
            return "SCAA杯测表"
          } else if(cellValue == 3){
            return "COE杯测表"
          } else if(cellValue == 4){
            return "世界咖啡冲煮大赛（指定冲煮）感官评分表"
          } else if(cellValue == 5){
            return "世界咖啡烘焙大赛评分表"
          } else if(cellValue == 6){
            return "咖啡饮品感官评分简表"
          } else if(cellValue == 7){
            return "Roster’s Commu.烘焙赛评分表"
          }
          else {
            return "其它"
          }
        },
        formatCategory({ cellValue, row, column }) {
          let result
          for (let index = 0; index < this.constantActivityCategory.length; index++) {
            if (this.constantActivityCategory[index].key == cellValue) {
              result = this.constantActivityCategory[index].value
            }
          }
          return result
        },
        goDetail(uuid) {
          this.go("mp/activity/detail/"+uuid)
        },
        goGather(uuid) {
          this.go("mp/activity/gather/"+uuid)
        },
        go(where) {
          this.$router.push('/' + where)
        },
      }
    }
  </script>
  
  <style scoped>
    .container-activity {
      width: 100%;
      height: 100%;
      overflow: auto;
      position: relative;
      padding-left: 110px;
      padding-top: 30px;
      padding-right: 30px;
      padding-bottom: 30px;
    }
    .small-text {
        font-size: 12px;
        line-height: 1.4;
        color: #999999;
    }

    .btn-upload {
      position: relative;
      display: inline-block;
      box-sizing: border-box;
      text-align: center;
      background-color: #fff;
      outline: 0;
      font-size: 14px;
      margin-left: 12px;
      cursor: pointer;
      padding: 0 1em;
      height: 34px;
      line-height: 32px;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      color: #606266;
      cursor: pointer;
    }
    .upload-text {
        display: inline-block;
        cursor: pointer;
    }

    .upload-input {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        cursor: pointer;
        z-index: 2;
    }
  </style>